import React from 'react';
import { useStyletron } from 'baseui';
import _isString from 'lodash/isString';
import { EMPTY_STRING } from 'commons-ui';

interface IFooterProps {
	message?: string;
}

const Footer: React.FC<IFooterProps> = (props) => {
	const { message = EMPTY_STRING } = props;
	const [css] = useStyletron();
	const footerStyle = css({
		padding: '10px',
		backgroundColor: 'lightgrey',
		textAlign: 'center'
	});

	return <div className={footerStyle}>{_isString(message) && `${message}`}</div>;
};

export default Footer;
